<script lang="ts">
  import { type Size, SIZE_MAP } from './icon';
  interface Props {
    size?: Size;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
  }
  let { size = $bindable('md'), ...rest }: Props = $props();
  let computedSize = $derived(SIZE_MAP[size] as Size);
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width={computedSize}
  height={computedSize}
  viewBox="0 0 24 24"
  {...rest}>
  <g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13 4.062V4.5a1 1 0 0 1-2 0v-.438A7.96 7.96 0 0 0 7.094 5.68l.31.31A1 1 0 1 1 5.99 7.404l-.31-.31A7.96 7.96 0 0 0 4.062 11H4.5a1 1 0 0 1 0 2h-.438A8.004 8.004 0 0 0 11 19.938V19.5a1 1 0 0 1 2 0v.438a7.96 7.96 0 0 0 3.906-1.618l-.31-.31a1 1 0 0 1 1.414-1.414l.31.31A7.96 7.96 0 0 0 19.938 13H19.5a1 1 0 0 1 0-2h.438A8.004 8.004 0 0 0 13 4.062ZM2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12Zm14.466-5.156-5.693 3.622a1 1 0 0 0-.307.307l-3.622 5.693c-.287.45.24.977.69.69l5.693-3.623a1 1 0 0 0 .306-.306l3.623-5.693c.287-.451-.24-.977-.69-.69Z"
      fill="currentColor" />
  </g>
</svg>
